<div *ngIf="!hideFooter" class="footer">
  <div class="footer-content" style="display: block;">
    <span class="bold primary font13"> <span >ENACT SYSTEMS INC. &copy; {{currentYear}}-{{currentYear + 1}}</span>
    </span> &nbsp; &nbsp; <span>
      <a href="https://x.com/ENACTSOLAR" target="_blank" class="icon-space"><img src="../../../../assets/images/social/twitter.png"
        class="size18" /></a>
      <a href="https://www.linkedin.com/company/enact-systems-inc/" target="_blank" class="icon-space"><img src="../../../../assets/images/social/linkedin.png"
        class="size18" /></a>
      <a href="https://www.youtube.com/@enactsolar" target="_blank" class="icon-space"><img src="../../../../assets/images/social/youtube.png"
        class="size18" /></a>
      <a href="https://www.facebook.com/Enact.Solar" target="_blank" class="icon-space"><img src="../../../../assets/images/social/facebook.png"
        class="size18" /></a>
    </span>
  </div>
</div>
